export default __webpack_public_path__ + "static/item-4f63bfb81866fec472081917d062afa2.jpg";